import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  driverStatusError: {
    color: theme.errorBorderColor,
    fontSize: theme.textFontSize,
    display: "block",
  },
  errorPadding: {
    padding: "2px 4px",
  },
  errorLine: {
    display: "block",
  },
});

const DriverErrorDisplay = ({ driverError, classes }) => (
  <div className={`${classes.driverStatusError} ${classes.errorPadding}`}>
    {driverError?.statusError && (
      <div className={classes.errorLine}>{driverError.statusError}</div>
    )}
    {driverError?.error && (
      <div className={classes.errorLine}>{driverError.error}</div>
    )}
  </div>
);

export default withStyles(styles)(DriverErrorDisplay);
